module.exports = __webpack_public_path__ + "img/wxXcx.b8df8012.png";